<div provide-parent-form *ngIf="lineitem?.playout">

	<h3>{{ 'GENERAL' | translate }}</h3>
		
	<bb-form-element [form]="form" invalidMessage="The title is required" [label]="'TITLE' | translate">
		<input [(ngModel)]="lineitem.title" type="text" required name="title" (ngModelChange)="updateCode()" />
	</bb-form-element>
		
	<bb-form-element [form]="form" [label]="'CODE' | translate" [disabled]="!isNew">
		<input [class.disabled]="!isNew" [disabled]="isNew ? null : ''" [(ngModel)]="lineitem.code" type="text" name="code" (ngModelChange)="onCodeUpdated(lineitem.code)" />
	</bb-form-element>
	
	<bb-form-element [form]="form" [label]="'DESCRIPTION' | translate">
		<textarea [(ngModel)]="lineitem.description" type="text" name="description">{{lineitem.description}}</textarea>
	</bb-form-element>
	
	<bb-form-element [form]="form" [label]="'TIMEOUT' | translate">
		<input [(ngModel)]="lineitem.timeout" type="number" name="timeout" />
	</bb-form-element>
 
	<div *ngIf="lineitem.creativeType === 'VAST'">
		<h3>{{ 'CREATIVE' | translate }}</h3>

		<bb-form-element [form]="form" [label]="'VAST_SUBTYPE' | translate">
			<input [(ngModel)]="lineitem.vast_subtype" type="text" name="vast_subtype" />
		</bb-form-element>
	
		<bb-form-element *ngIf="lineitem.usePrebid === 'true'" [form]="form" [label]="'DIRECTLY_USE_WINNING_BID' | translate">
			<bb-check [(ngModel)]="lineitem.prebid_direct" name="prebid_direct" trueValue="true" falseValue="false"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'VAST_URL' | translate">
			<textarea [(ngModel)]="lineitem.vast_url" type="text" name="vast_url" [disabled]="lineitem.prebid_direct === 'true' && lineitem.usePrebid === 'true'">{{lineitem.vast_url}}</textarea>
		</bb-form-element>
	</div>
	
		
	<h3>{{ 'CONDITIONS' | translate }} 
		<bb-info [contents]="'HELP.LINE_ITEM_CONDITIONS' | translate" [icon]="'help'"></bb-info>
	</h3>

	<bb-filter-set name="filters" [filterConfig]="conditionOptions" [(ngModel)]="lineitem.conditions"></bb-filter-set>
	
	<h3>{{ 'BEHAVIOUR' | translate }}</h3>

	<bb-form-element
		[hasPermission]="'bidadapters'"
		[form]="form" [label]="'USE_PREBID_JS' | translate" [helpMessage]="'HELP.USE_PREBID_JS' | translate">
		<bb-check [(ngModel)]="lineitem.usePrebid" name="usePrebid" trueValue="true" falseValue="false"></bb-check>
	</bb-form-element>

	<bb-form-element
		[hasPublicationField]="'blockInsecureVPAID'"
		[form]="form" [label]="'BLOCK_INSECURE_VPAID' | translate" [helpMessage]="'HELP.BLOCK_INSECURE_VPAID' | translate">
		<bb-check [(ngModel)]="lineitem.playout.blockInsecureVPAID" name="blockInsecureVPAID" trueValue="true" falseValue="false"></bb-check>
	</bb-form-element>

	<bb-form-element
		[form]="form" [label]="'LOAD_VAST_URL_FROM_SAME_DOMAIN' | translate" [helpMessage]="'HELP.LOAD_VAST_URL_FROM_SAME_DOMAIN' | translate">
		<bb-check [(ngModel)]="lineitem.vastPrefetch" name="vastPrefetch" trueValue="true" falseValue="false"></bb-check>
	</bb-form-element>

	<bb-form-element
		[hasPublicationField]="'imaCustomPlaybackForIOS10Plus'"
		[form]="form" [label]="'IMA_CUSTOM_PLAYBACK_IOS10' | translate" [helpMessage]="'HELP.IMA_CUSTOM_PLAYBACK_IOS10' | translate">
		<bb-select [(ngModel)]="lineitem.playout.imaCustomPlaybackForIOS10Plus" name="imaCustomPlaybackForIOS10Plus">
			<option value="">{{ 'IMA_CUSTOM_PLAYBACK_IOS10_NONE' | translate }} ({{ 'DEFAULT' | translate }})</option>
			<option value="false">{{ 'DISABLED' | translate }}</option>
			<option value="true">{{ 'ENABLED' | translate }}</option>
		</bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'PLAYOUT_COMMERCIAL_BEHAVIOUR' | translate">
		<bb-select [(ngModel)]="lineitem.playout.commercialBehaviour" name="commercialBehaviour">
			<option value="">{{ 'PLAYOUT_COMMERCIAL_BEHAVIOUR_NONE' | translate }} ({{ 'DEFAULT' | translate }})</option>
			<option value="Once per load">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_LOAD' | translate }}</option>
			<option value="Once per session">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_SESSION' | translate }}</option>
			<option value="Once per clip">{{ 'PLAYOUT_COMMERCIAL_ONCE_PER_CLIP' | translate }}</option>
		</bb-select>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'PLAYOUT_MINIMUM_CLIP_DURATION_FOR_PREROLL' | translate">
		<input [(ngModel)]="lineitem.playout.minClipDurationPreroll" type="number" name="minClipDurationPreroll" [placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate" />
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'PLAYOUT_MINIMUM_CLIP_DURATION_FOR_POSTROLL' | translate">
		<input [(ngModel)]="lineitem.playout.minClipDurationPostroll" type="number" name="minClipDurationPostroll" [placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate" />
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'ALLOW_SKIPPING' | translate">
		<bb-check [(ngModel)]="allowSkipping" (ngModelChange)="updateSkipOffset()" [ngModelOptions]="{standalone: true}"></bb-check>
	</bb-form-element>

	<div [hidden]="!lineitem.playout.skipOffset || lineitem.playout.skipOffset < 0">
		<bb-form-element [form]="form" [label]="'SKIP_COUNTDOWN_TEXT' | translate">
			<div class="input">
				<input class="skip-counter-text" type="text" [(ngModel)]="lineitem.playout.skipCounterText" name="skipCounterText"/>
				<input class="skip-counter-offset" type="number" [(ngModel)]="lineitem.playout.skipOffset" name="skipOffset" /> {{ 'SECONDS' | translate | lowercase }}.
			</div>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'SKIP_BUTTON_TEXT' | translate">
			<input [(ngModel)]="lineitem.playout.skipButtonText" type="text" name="skipButtonText" />
		</bb-form-element>
	</div>

	
	<h3>{{ 'DISPLAY_SETTINGS' | translate }}</h3>

	<bb-form-element [form]="form" [label]="'DISABLE_CONTROLS' | translate">
		<bb-check [(ngModel)]="lineitem.playout.disableControls" name="disableControls" trueValue="true" falseValue="false"></bb-check>
	</bb-form-element>
</div>
